import { Table } from "@mantine/core";

/**
 * A data table that never clips a column on a phone. Wraps Mantine's Table in a horizontal scroll
 * container, so a table wider than the viewport scrolls inside its own box instead of pushing the
 * page (the body never scrolls sideways). Drop-in replacement for a bare `<Table>` — pass the same
 * children (Table.Thead / Table.Tbody) and Table props.
 *
 *   <ResponsiveTable minWidth={480}> …Table.Thead / Table.Tbody… </ResponsiveTable>
 */
export default function ResponsiveTable({ minWidth = 480, children, ...tableProps }) {
  return (
    <Table.ScrollContainer minWidth={minWidth}>
      <Table {...tableProps}>{children}</Table>
    </Table.ScrollContainer>
  );
}
